import { configureStore } from "@reduxjs/toolkit";
import dialogSlice from "../components/dialog/dialogSlice";
import loginReducer from "../features/login/loginSlice";
import countrySlice from "../features/country/countrySlice";
import muiDrawerSlice from "../components/muidrawer/muiDrawerSlice";
import stateSlice from "../features/state/stateSlice";
import citySlice from "../features/city/citySlice";
import itemcategorySlice from "../features/itemcategory/itemcategorySlice";
import itemSlice from "../features/item/itemSlice";
import processSlice from "../features/process/processSlice";
import prioritySlice from "../features/priority/prioritySlice";
import partySlice from "../features/party/partySlice";
import karigarSlice from "../features/karigar/karigarSlice";
import orderSlice from "../features/order/orderSlice";
import ghatSlice from "../features/ghat/ghatSlice";
import ghatReceiptSlice from "../features/ghatreceipt/ghatReceiptSlice";
import productsubcategorySlice from "../features/productsubcategory/productsubcategorySlice";
import puritySlice from "../features/purity/puritySlice";
import unitSlice from "../features/unit/unitSlice";
import chargesSlice from "../features/charges/chargesSlice";
import paginationSlice from "../features/pagination/paginationSlice";
import userSlice from "../features/user/userSlice";
import userTypeSlice from "../features/userType/userTypeSlice";
import menuSlice from "../features/menu/menuSlice";
import rightsSlice from "../features/rights/rightsSlice";
import palishSlice from "../features/palish/palishSlice";
import palishReceiptSlice from "../features/palishreceipt/palishReceiptSlice";
import dullSlice from "../features/dull/dullSlice";
import dullReceiptSlice from "../features/dullreceipt/dullReceiptSlice";
import minaSlice from "../features/mina/minaSlice";
import minaReceiptSlice from "../features/minareceipt/minaReceiptSlice";
import jadaiSlice from "../features/jadai/jadaiSlice";
import jadaiReceiptSlice from "../features/jadaireceipt/jadaiReceiptSlice";
import bandhaiSlice from "../features/bandhai/bandhaiSlice";
import bandhaiReceiptSlice from "../features/bandhaireceipt/bandhaiReceiptSlice";
import reportSlice from "../features/reports/reportSlice";
import paymentreceiptSlice from "../features/paymentreceipt/paymentreceiptSlice";
import settlementformSlice from "../features/settlementform/settlementformSlice";
import partAddtoOrdersReducer from "../features/addparts/partAddtoOrdersSlice";
import orderLabelingReducer from "../features/orderlabeling/orderLabelingSlice";
import purchaseSlice from "../features/purchaseform/purchaseSlice";
import splitItemReducer from "../features/splititem/splitItemSlice";

// const customizedMiddleware = () =>
//   getDefaultMiddleware({
//     serializableCheck: false,
//   });

const store = configureStore({
  reducer: {
    login: loginReducer,
    dialog: dialogSlice,
    reports: reportSlice,
    // drawer: drawerSlice,
    muidrawer: muiDrawerSlice,
    country: countrySlice,
    user: userSlice,
    userType: userTypeSlice,
    menu: menuSlice,
    rights: rightsSlice,
    state: stateSlice,
    city: citySlice,
    itemCategory: itemcategorySlice,
    item: itemSlice,
    Process: processSlice,
    priority: prioritySlice,
    party: partySlice,
    karigar: karigarSlice,
    order: orderSlice,
    ghat: ghatSlice,
    ghatreceipt: ghatReceiptSlice,
    productsubcategory: productsubcategorySlice,
    purity: puritySlice,
    unit: unitSlice,
    charges: chargesSlice,
    pagination: paginationSlice,
    palish: palishSlice,
    palishreceipt: palishReceiptSlice,
    dull: dullSlice,
    dullreceipt: dullReceiptSlice,
    mina: minaSlice,
    minareceipt: minaReceiptSlice,
    jadai: jadaiSlice,
    jadaireceipt: jadaiReceiptSlice,
    bandhai: bandhaiSlice,
    bandhaireceipt: bandhaiReceiptSlice,
    paymentreceipt: paymentreceiptSlice,
    settlementform: settlementformSlice,
    partAddtoOrders: partAddtoOrdersReducer,
    orderLabeling: orderLabelingReducer,
    purchase: purchaseSlice,
    splitItem: splitItemReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
